<template>
  <div v-if="showComponent"
       :title="qaAble ? showIfHasPermission?.toString() : null"
       :key="componentRefresh">
    <vue-editor v-model="input"/>
  </div>
</template>

<script>
import {VueEditor} from 'vue2-editor';
import checkPermissions from '../../mixins/checkPermissions';

export default {

  name: 'rich-text-editor',
  mixins: [checkPermissions],
  props: {
    dataSource: {
      type: String,
      required: true
    },
    defaultValue: {
      default: null
    },
    index: {
      type: Number,
      default: null
    },
  },
  components: {VueEditor},
  watch: {
    input: function (val, oldVal) {
      if (this.defaultValue !== null && val === undefined) {
        this.input = this.defaultValue;
      }
    }
  },
  mounted() {
    if (this.defaultValue !== null) {
      this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, this.defaultValue);
    }
    this.$emit('onMounted', this);
    setTimeout(() => {
      app.dataproviders[this.dataProviderName].inputs[this.dataSource] = this;
    }, 500);
  },
  data() {
    return {}
  },
  methods: {},
  computed: {
    dataProviderName() {
      return this.$parent.dataProvider;
    },
    inputType() {
      return this.$parent.type;
    },
    input: {
      get() {
        if (this.inputType === 'list') {
          return this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource];
        } else {
          return this.$parent.data_provider_ref[this.inputType][this.dataSource];
        }
      },
      set(newval) {
        if (this.inputType === 'list') {
          this.$set(this.$parent.data_provider_ref[this.inputType][this.index], this.dataSource, newval);
        } else {
          this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, newval);
        }
      }
    },
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    },
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  }
}
</script>
